console.log('✅ wishlist.js loaded');

// Update the appearance and attributes of a wishlist button based on wishlist state
function updateWishlistButton(button, isInWishlist) {
  if (!button) return;

  console.log('Updating wishlist button:', button, 'isInWishlist:', isInWishlist);

  // Handle both .wishlist-button and .modern-product-wishlist
  const isModernButton = button.classList.contains('modern-product-wishlist');
  const icon = button.querySelector('.modern-product-wishlist-icon');
  const svg = button.querySelector('svg');
  const path = button.querySelector('path');
  const fallback = button.querySelector('.wishlist-fallback');

  if (isInWishlist) {
    button.classList.add('wishlisted', 'favorited');
    button.setAttribute('aria-label', 'Remove from wishlist');
    button.title = 'Remove from wishlist';

    if (isModernButton && icon) {
      // Modern button styling
      button.style.color = '#ff6b6b';
      icon.style.backgroundImage = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z' fill='%23ff6b6b'/%3E%3C/svg%3E")`;
    } else {
      // Standard button styling
      button.style.color = '#ff6b6b';
      if (path) {
        path.setAttribute('fill', '#ff6b6b');
        path.setAttribute('stroke', '#ff6b6b');
      }
      if (fallback) {
        fallback.textContent = '♥'; // Filled heart
      }
    }
  } else {
    button.classList.remove('wishlisted', 'favorited');
    button.setAttribute('aria-label', 'Add to wishlist');
    button.title = 'Add to wishlist';

    if (isModernButton && icon) {
      // Modern button reset
      button.style.color = '';
      icon.style.backgroundImage = `url("${window.location.origin}/assets/heart.png")`;
    } else {
      // Standard button reset
      button.style.color = '';
      if (path) {
        path.setAttribute('fill', 'none');
        path.setAttribute('stroke', 'currentColor');
      }
      if (fallback) {
        fallback.textContent = '♡'; // Empty heart
      }
    }
  }
}

// Show a wishlist toast message
function showWishlistMessage(message) {
  console.log('Showing wishlist message:', message);

  // Remove any existing toast first
  const existingToast = document.querySelector('.wishlist-toast');
  if (existingToast) {
    existingToast.remove();
  }

  // Create a simple toast notification
  const toast = document.createElement('div');
  toast.className = 'wishlist-toast';
  toast.textContent = message;
  toast.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #333;
    color: white;
    padding: 12px 20px;
    border-radius: 4px;
    z-index: 10000;
    font-family: 'Albert Sans', sans-serif;
    font-size: 14px;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  `;

  document.body.appendChild(toast);

  // Show the toast
  setTimeout(() => {
    toast.style.opacity = '1';
  }, 10);

  // Hide and remove the toast
  setTimeout(() => {
    toast.style.opacity = '0';
    setTimeout(() => {
      if (toast.parentNode) {
        toast.remove();
      }
    }, 300);
  }, 2500);
}

function initWishlistButtonsInScope(scope = document) {
  const buttons = scope.querySelectorAll('.wishlist-button, .modern-product-wishlist');

  buttons.forEach(button => {
    // Skip if already initialized to prevent duplicate event listeners
    if (button.dataset.wishlistInitialized === 'true') {
      return;
    }
    button.dataset.wishlistInitialized = 'true';
    const productId = parseInt(button.dataset.productId, 10);
    const productTitle = button.dataset.productTitle;
    const productHandle = button.dataset.productHandle;
    const productImage = button.dataset.productImage;
    const productPrice = button.dataset.productPrice;

    let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const isInWishlist = wishlist.some(item => item.id === productId);
    updateWishlistButton(button, isInWishlist);

    button.addEventListener('click', function (e) {
      // Only prevent default and stop propagation for the button itself
      e.preventDefault();
      e.stopPropagation();

      wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
      const currentlyInWishlist = wishlist.some(item => item.id === productId);

      if (currentlyInWishlist) {
        wishlist = wishlist.filter(item => item.id !== productId);
        updateWishlistButton(button, false);
        showWishlistMessage('Removed from wishlist');
      } else {
        wishlist.push({
          id: productId,
          title: productTitle,
          handle: productHandle,
          image: productImage,
          price: productPrice,
          url: `/products/${productHandle}`
        });
        updateWishlistButton(button, true);
        showWishlistMessage('Added to wishlist');
      }

      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      window.dispatchEvent(new CustomEvent('wishlistUpdated', {
        detail: { productId, isInWishlist: !currentlyInWishlist }
      }));
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('⏳ DOMContentLoaded fired');
    initWishlistButtonsInScope();
  });
} else {
  console.log('⚡ DOM already loaded');
  initWishlistButtonsInScope();
}

window.initWishlistButtonsInScope = initWishlistButtonsInScope;